import React from "react";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { useCreateCategory } from "../hooks";
import { CategoryForm } from "../components";

export const CreateCategory: React.FC = () => {
  const { form, submit, loading } = useCreateCategory({
    defaultValues: {},
    onCompleted: () => {
      toast.success("La catégorie a été créée avec succès");
    },
  });

  return (
    <>
      <Header
        title="Catégorie"
        subtitle="Créer une nouvelle catégorie"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/categories`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Nouvelle catégorie" />
          <CategoryForm loading={loading} submit={submit} form={form} />
        </div>
      </div>
    </>
  );
};
